module.exports = __webpack_public_path__ + "files/b3f3c6c4dc0477acad569a6b09be0cfa.svg";